<template>
  <div class="pb-0 pt-c-1">
    <div class="float-left blue-grey--text text--darken-1 size-13 my-0">
      {{header.hasOwnProperty('menu') || header.hasOwnProperty('actions') ? '' : header.text}}
    </div>
    <div class="text-right text--darken-1 size-13 my-0">
      <div v-if="header.hasOwnProperty('icon')">
        <v-icon :color='header.icon.color || "primary"' class='size-20' v-if="header.icon.onClick" @click='header.icon.onClick(column, index)'>
          {{header.icon.value}}
        </v-icon>
      </div>

        <div v-else-if="header.hasOwnProperty('span')">
          <span :class="`${header.span.color(column[header.value])}--text`">
            {{header.span.formatter(header.value.indexOf('.') !== -1 ? column[header.value.split(".")[0]][header.value.split(".")[1]] : column[header.value], column) }}
          </span>
        </div>

      <div v-else-if="header.hasOwnProperty('chip')">
        <v-chip :color='header.chip.color(column[header.value])' dark small class="pa-2">
          {{header.chip.formatter(header.value.indexOf('.') !== -1 ? column[header.value.split(".")[0]][header.value.split(".")[1]] : column[header.value], column) }}
        </v-chip>
      </div>

      <div v-else-if="header.hasOwnProperty('formatter')">
        {{header.formatter(header.value.indexOf('.') !== -1 ? column[header.value.split(".")[0]][header.value.split(".")[1]] : column[header.value], column) | cutLongStr}}
      </div>

      <div v-else-if="header.hasOwnProperty('avatar')">
        <v-avatar size="36">
            <img
              v-if="header.avatar(column[header.value])"
              :src="header.avatar(column[header.value])"
            >
            <v-img v-else :src="require('@/assets/def-head.jpeg')" />
        </v-avatar>
      </div>
      <div v-else>
        {{ header.value.indexOf('.') !== -1 ? column[header.value.split(".")[0]][header.value.split(".")[1]] : column[header.value]}}
      </div>
    </div>
  </div>
</template>

<script>
  import { isEmpty, cutString, isNumber } from '@/utils/stringUtil.js'

  export default {
    name: 'MobileTable',
    props: {
      header: {
        type: Object,
        require: true
      },
      index: {
        type: Number,
        default: 0
      },
      column: {
        type: Object,
        require: true
      }
    },
    filters: {
      cutLongStr (val) {
        if (isNumber(val)) {
          return val
        } else if (!isEmpty(val)) {
          return cutString(val, 20)
        }
        return ''
      }
    },
  }
</script>
